import { AppNS } from 'app';
import { useGetCompanyQuery } from 'app/api_v2/agency/queries';
import { useAuthStore } from 'app/core/store_v2/auth';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import ErrorsList from 'app/ui_v2/components/errors-list/ErrorsList';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Box } from '@mui/material';

import { agencyProfileResolverGuards, canUserAccessProfile } from './resolver-guards';

export interface AgencyProfileResolverProps {
  children: any;
}

export default function AgencyProfileResolver(props: AgencyProfileResolverProps) {
  const { children } = props;
  const { currentUser } = useAuthStore();
  const { id = '' } = useParams();

  const location = useLocation();

  const navigate = useNavigate();

  const [redirect, setRedirect] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean>(false);

  useEffect(() => {
    if (redirect !== '') {
      navigate(redirect);
      setRedirect('');
      setIsValid(true);
    }
  }, [redirect, navigate]);

  const { isLoading, isError, error, isSuccess, data } = useGetCompanyQuery(id, {
    enabled: id !== '' && Boolean(currentUser) && canUserAccessProfile(id, currentUser as AppNS.User),
    cacheTime: 1000,
  });

  useEffect(() => {
    if (isSuccess) {
      let redirect = '';
      redirect = agencyProfileResolverGuards(data, location, currentUser as AppNS.User);

      if (redirect !== '') {
        setRedirect(redirect);
        setIsValid(false);
      } else {
        setIsValid(true);
      }
    }
  }, [isSuccess /*, location, data*/]);

  useEffect(() => {
    if (currentUser) {
      let result = false;
      result = canUserAccessProfile(id, currentUser as AppNS.User);
      if (!result) {
        setRedirect('/agency');
        setIsValid(false);
      }
    }
  }, [currentUser]);

  useEffect(() => {
    if (isError) {
      // just to show error message
      setIsValid(true);
    }
  }, [isError]);

  if (isLoading || !isValid) {
    return (
      <Box mt={4}>
        <DataLoader />
      </Box>
    );
  }

  if (!isLoading && isError) {
    return (
      <Box p={3}>
        <ErrorsList title="Unexpected loading error" errors={error as string[]} />
      </Box>
    );
  }

  return <>{children}</>;
}
